import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['fixedPicker', 'otherPicker']

  connect() {
    const currentValue = this.fixedPickerTarget.querySelector('select').value

    this.handleOtherPicker(currentValue)
  }

  change() {
    const value = event.currentTarget.value

    this.handleOtherPicker(value)
  }

  handleOtherPicker(value) {
    if (value == 'other') {
      this.otherPickerTarget.style.display = 'block'
    } else {
      this.otherPickerTarget.style.display = 'none'
    }
  }
}
